import React from "react";
import i18next from "i18next";
import "consignment-stock/css/index.css";
import { Auart, DebitorQuantityContract } from "../services/contractApi";
import { getDateFormatted } from "../../common/scripts/format/date";

type Props = {
  debitorQuantityContracts: DebitorQuantityContract[];
};

const ContractHeader: React.FC = () => {
  return (
    <div className="list-4cols list-4cols--header">
      <div className="list__col">{i18next.t("MATERIAL GROUP")}</div>
      <div className="list__col">{i18next.t("NUMBER ITEM")}</div>
      <div className="list__col">{i18next.t("OPEN QUANTITY")}</div>
      <div className="list__col">{i18next.t("VALID UNTIL")}</div>
    </div>
  );
};

const ContractItem: React.FC<{ contract: DebitorQuantityContract }> = ({ contract }) => {
  return (
    <div className="list-4cols">
      <div className="list__col list__col--link cursor-auto">{contract.vtext}</div>
      <div className="list__col">{[contract.vbeln, contract.posnr].join(", ")}</div>
      <div className="list__col">{contract.omeng}</div>
      <div className="list__col">{getDateFormatted(contract.gueen)}</div>
    </div>
  );
};

const ContractsSection: React.FC<{ title: string; contracts: DebitorQuantityContract[] }> = ({
  title,
  contracts,
}) => {
  if (contracts.length === 0) {
    return null;
  }

  return (
    <>
      <h2 className="list-top-title">{title}</h2>
      <div className="list-wrap">
        <ContractHeader />
        {contracts.map(contract => (
          <ContractItem key={`${contract.vbeln}-${contract.posnr}`} contract={contract} />
        ))}
      </div>
    </>
  );
};

const ContractsContent: React.FC<Props> = ({ debitorQuantityContracts }) => {
  const contractsNotPrepaid = debitorQuantityContracts.filter(
    contract => contract.auart === Auart.NotPrepaid,
  );
  const contractsPrepaid = debitorQuantityContracts.filter(
    contract => contract.auart === Auart.Prepaid,
  );

  return (
    <>
      <h1 className="col-title">{i18next.t("CONTRACTS")}</h1>
      <div className="hr" />
      <ContractsSection
        title={i18next.t("CONTRACTS WITHOUT PREPAYMENT")}
        contracts={contractsNotPrepaid}
      />
      <ContractsSection
        title={i18next.t("CONTRACTS WITH PREPAYMENT")}
        contracts={contractsPrepaid}
      />
    </>
  );
};

export default ContractsContent;
